import { $qs, $qsa } from '../../utils/QuerySelector';
import gsap from 'gsap';
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, FreeMode } from 'swiper';






function testimonial_home() {
   
       
        
        var swiper = new Swiper(".swiper[data-element='testimonialhome_carousel']", {
            modules: [Navigation, Pagination, Scrollbar, Autoplay],
            loop: true,
            slidesPerView: 1,
            spaceBetween: 24,
            breakpoints: {
                1310: {
                  slidesPerView: 2.5,
                  spaceBetween: 32
                }
              },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
   
     
 }
 
 export default testimonial_home;
